import { ElementRef } from "@angular/core";

export function toggleInputType(input: ElementRef, show: boolean) {
  input.nativeElement.type = show ? 'text' : 'password';
  const valueLength = input.nativeElement.value.length;
  input.nativeElement.focus();
  setTimeout(() => input.nativeElement.setSelectionRange(valueLength, valueLength), 0);
}